var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWait(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 15,
    viewBox: "0 0 12 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.347656 0.986328V2.54188H1.90321V3.58702C1.90321 4.61799 2.31251 5.60753 3.04253 6.33659L4.69228 7.98633L3.04253 9.63607C2.31251 10.3651 1.90321 11.3547 1.90321 12.3856V13.4308H0.347656V14.9863H11.2365V13.4308H9.68099V12.3856C9.68099 11.3548 9.27068 10.3651 8.54167 9.63607L6.89193 7.98633L8.54167 6.33659C9.27127 5.60699 9.68099 4.61799 9.68099 3.58702V2.54188H11.2365V0.986328H0.347656ZM3.45877 2.54188H8.12543V3.58702C8.12543 4.2065 7.88046 4.79814 7.44184 5.23676L5.7921 6.8865L4.14236 5.23524C3.70417 4.79763 3.45877 4.2065 3.45877 3.58702V2.54188ZM5.7921 9.08615L7.44184 10.7359C7.87949 11.1735 8.12543 11.7676 8.12543 12.3856V13.4308H7.19423C6.81085 12.4 5.7921 11.8752 5.7921 11.8752C5.7921 11.8752 4.77335 12.4 4.38997 13.4308H3.45877V12.3856C3.45877 11.7662 3.70417 11.175 4.14236 10.7374L5.7921 9.08615Z",
    fill: "#5C5F62"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWait);
export default __webpack_public_path__ + "static/media/wait.bd99abefb09b01f148a85e0540909940.svg";
export { ForwardRef as ReactComponent };